module.exports = __webpack_public_path__ + "static/media/vedio.efe4a9c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vedio.mp4
// module id = LOwV
// module chunks = 1